import React, { useEffect, useState } from "react";
import { Receipt, Sparkles } from "lucide-react";
import client, { money } from "@/lib/api";
import ReceiptScanner from "@/components/ReceiptScanner";
import PageHero from "@/components/PageHero";

export default function Receipts() {
  const [receipts, setReceipts] = useState([]);
  const load = () => client.get("/receipts").then((r) => setReceipts(r.data)).catch(() => setReceipts([]));
  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-2xl mx-auto space-y-5">
      <PageHero image="/img/bakery.jpg" eyebrow="Receipts" title="Snap it, we'll read it" subtitle="We read every item, track real spending and keep store prices accurate for everyone." testId="receipts-hero" />
      <ReceiptScanner onSaved={load} />
      <div className="space-y-2">
        {receipts.map((r) => (
          <div key={r.id} data-testid={`receipt-${r.id}`} className="bg-white rounded-2xl p-4 pp-shadow flex items-center gap-3">
            <span className="grid place-items-center h-10 w-10 rounded-xl bg-[#EBF7EE] text-pp-forest"><Receipt className="h-5 w-5" /></span>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-pp-text truncate">{r.retailer || "Receipt"}</p>
              <p className="text-xs text-pp-muted">{r.date} · {r.items?.length ? `${r.items.length} items` : "total only"}
                {r.prices_learned ? <span className="text-pp-forest font-semibold"> · <Sparkles className="inline h-3 w-3" /> {r.prices_learned} prices updated</span> : null}</p>
            </div>
            <p className="font-extrabold text-pp-text">{money(r.total)}</p>
          </div>
        ))}
        {!receipts.length && <p className="text-center text-sm text-pp-muted py-6">No receipts yet.</p>}
      </div>
    </div>
  );
}
